<template>
  <div id="admin">
    <menu-admin/>
    <div class="jumbotron jumbotron-fluid">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1 class="title text-center">
              <i class="fa fa-order"></i>
              <span>Pedido #{{order.id}}</span>
            </h1>
          </div>
        </div>
      </div>
    </div>

    <section class="int-form">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="card-control">
              <h3 class="title">Histórico</h3>
              <ul>
                <li v-show="history.length == 0">Nenhum registro encontrado</li>
                <li v-for="log in history" :key="log">
                  <div class="baloon">{{log.action}}</div>
                  <div class="when">{{log.created | formatDateTime}} por <strong>{{log.actor.name}}</strong></div>
                </li>
              </ul>
            </div>
            <form style="float:left">
              <div class="card-details col-12">
                <h3 class="title">Detalhes do pedido</h3>
                <div class="row">
                  <div class="form-group col-sm-4">
                    <label>Valor total</label>
                    <br/>R$ {{ order.total | formatPrice }}
                  </div>

                  <div class="form-group col-sm-4">
                    <label>Data da compra</label>
                    <br/>{{ order.date | formatDate }}
                  </div>


                  <div class="form-group col-sm-4">
                    <label>Status do pedido</label>
                    <br/>
                    <select id="status" class="form-control" v-model="order.status">
                      <option v-show="has_photo_upload" value="4">Em análise</option>
                      <option value="1">Pagamento pendente</option>
                      <option value="2">Pagamento confirmado</option>
                      <option value="3">Cancelado</option>
                    </select>
                  </div>
                  <div class="form-group col-sm-4">
                    <label>Pagamento</label>
                    <br/>
                    <span v-if="order.transaction_link"><a target="_blank" :href="order.transaction_link">Boleto Gerado</a></span>
                    <span v-else>Boleto não gerado</span>
                  </div>

                  <div v-if="order.shipping_value > 0" class="form-group col-sm-4">
                    <label>Tipo do envio</label>
                    <br/>{{ order.shipping_type }}
                  </div>
                  <div v-if="order.shipping_value > 0" class="form-group col-sm-4">
                    <label>Valor do envio</label>
                    <br/>R$ {{ order.shipping_value | formatPrice }}
                  </div>

                  <div class="form-group col-sm-4">
                    <label>Expedição</label>
                    <br/>
                    <span v-if="order.expeditions.length > 0"><a :href="'/admin/expedition/' + order.expeditions[0].id">#{{ order.expeditions[0].id }}</a> ({{ order.expeditions[0].status.name }})</span>
                    <span v-else><a href="/admin/expedition/0">Adicionar</a></span>
                  </div>

                </div>
                <div class="row"  v-show="(order.status === '3' || order.status === 3) && order.reason != ''">
                  <div class="form-group col-sm-12">
                    <div  class="alert alert-danger" role="alert">
                      <strong>PEDIDO REPROVADO</strong><br/>
                      {{ order.reason }}
                    </div>
                  </div>
                </div>
                <div class="row"  v-show="order.status === 4 || order.status === '4'">
                  <div class="form-group col-sm-12">
                    <a v-show="order.status === '4' || order.status === 4" class="btn btn-danger pull-left"  data-toggle="modal" data-target="#reasonModal" style="margin-top: 10px">Reprovar pedido</a>
                    <a v-show="order.status === '4' || order.status === 4" class="btn btn-primary pull-right" @click="aproveImages" style="margin-top: 10px">Aprovar Pedido</a>
                  </div>
                </div>
                <hr>
                <div class="row">
                  <div class="form-group col-sm-12">
                    <div class="card">
                      <div class="card-header">
                        Dados do cliente
                      </div>
                      <div class="card-body">
                        <b>Cliente: </b><span v-if="order.profile.person_or_company">{{ order.profile.company_name }}</span><span v-else>{{ order.profile.name }}</span><br/>
                        <b>E-mail: </b>{{ order.profile.user.email }}<br/>
                        <b>Telefone: </b>{{ order.profile.phone }}<br/>
                        <b><span v-if="order.profile.person_or_company">CNPJ</span><span v-else>CPF</span>: </b><span v-if="order.profile.person_or_company">{{ order.profile.cnpj }}</span><span v-else>{{ order.profile.cpf }}</span><br/>
                        <b>Insc. Est.: </b> <span v-if="order.profile.ie">{{ order.profile.ie }}</span><span v-else>-</span><br/>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="order.billing_address && order.shipping_address"  class="row">
                  <div class="form-group col-sm-6">
                    <div class="card">
                      <div class="card-header">
                        Endereço de nota fiscal
                      </div>
                      <div class="card-body">
                        {{order.billing_address.street}}, {{order.billing_address.number}}
                        <br/>{{order.billing_address.complement}}
                        <br/>{{order.billing_address.province}}
                        <br/>{{order.billing_address.city}} - {{order.billing_address.state}}
                        <br/>{{order.billing_address.country}}
                        <br/>{{order.billing_address.zip_code}}
                      </div>
                    </div>
                  </div>

                  <div class="form-group col-sm-6">
                    <div class="card">
                      <div class="card-header">
                        Endereço de envio
                      </div>
                      <div class="card-body">
                        {{order.shipping_address.street}}, {{order.shipping_address.number}}
                        <br/>{{order.shipping_address.complement}}
                        <br/>{{order.shipping_address.province}}
                        <br/>{{order.shipping_address.city}} - {{order.shipping_address.state}}
                        <br/>{{order.shipping_address.country}}
                        <br/>{{order.shipping_address.zip_code}}
                      </div>
                    </div>

                  </div>
                </div>
                <hr>
                <div class="row">
                  <div class="form-group col-sm-12">
                    <label>Publicações Selecionadas</label>
                    <ul class="list-group">
                      <li class="list-group-item" v-for="publication in order.publications" v-bind:key="publication.id"  style="background-color: #f7f7f7;">
                      <span class="pull-left">{{ publication.publication.name }}
                      <small>(R$ {{publication.value | formatPrice}})</small>
                      </span>
                        <div v-show="publication.publication.has_photo_upload">
                          <a class="pull-right" target="_blank" :href="publication.file"><img :src="publication.file" height="30" width="30" /></a>
                        </div>
                        <br/>
                        <ul style=" margin-left: 20px;" v-show="publication.publication.has_airplane_info">
                          <li><small>Prefixo da Aeronave:</small> {{ publication.airplane_prefix }}</li>
                          <li><small>Número de Série:</small> {{ publication.airplane_serial_number }}</li>
                          <li><small>Combustível:</small> {{ publication.fuel_type | nameFuelType }}</li>
                        </ul>
                      </li>
                    </ul>
                    <!-- Modal -->
                    <div class="modal fade" id="reasonModal" tabindex="-1" role="dialog" aria-labelledby="reasonModalLabel" aria-hidden="true">
                      <div class="modal-dialog" role="document">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title" id="reasonModalLabel">Reprovar pedido</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div class="modal-body">
                            <div class="form-group">
                              <label for="reprove">Informe para o cliente o motivo da reprovação:</label>
                              <textarea rows="6" id="reprove" class="form-control"></textarea>
                              <span class="errorForm"></span>
                            </div>
                          </div>
                          <div class="modal-footer">
                            <button type="button" id="hideModal" class="btn btn-secondary" data-dismiss="modal">Close</button>
                            <button type="button" class="btn btn-primary" @click="reproveOrder" >Save changes</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr  v-show="order.status === 2 || order.status === '2'">
                <div class="row" v-show="order.status === 2 || order.status === '2'">
                  <div class="form-group col-sm-12">
                    <div class="row">
                      <div class="form-group col-sm-12">
                        <label for="nfe">Nota fiscal eletrônica</label>
                        <br>
                        <input id="nfe" class="form-control" type="text" v-model="order.nfe" />
                      </div>
                    </div>
                  </div>
                </div>
                <hr>
                <div class="row">
                  <div class="form-group col-sm-12">
                    <label for="note">Observação</label>
                    <textarea id="note" rows="10" class="form-control" v-model="order.note"></textarea>
                    <span class="errorForm"></span>
                  </div>
                </div>
              </div>
              <hr/>
              <div class="card-details" style="padding-top: 0">
                <div class="row">
                  <div class="form-group col-sm-12">
                    <div id="sucessUpdate" class="alert alert-success text-center" role="alert" style="display: none;">As informações foram salvas com sucesso</div>
                    <div id="errorFound" class="alert alert-danger text-center" role="alert" style="display: none">Um erro foi encontrado. Verifique os campos do formulário</div>
                    <button type="button" class="btn btn-secondary" onclick="window.history.back()">Voltar</button>
                    <button type="button" class="btn btn-primary pull-right" @click="saveorder()">Salvar</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
    <footer-admin/>
  </div>
</template>

<script>
  import order from "../../api/order"
  import logme from "../../api/logme"
  import menuAdmin from "../admin/common/menu-admin"
  import footerAdmin from "../admin/common/footer-admin"
  import { mapState } from 'vuex'
  import mixins from "../../helpers/mixins"
  import {VMoney} from 'v-money'
  import axios from 'axios'
  import { CONFIGS } from '../../configs'

  export default {
    name: "AdminOrdersView",
    mixins: [mixins],
    data () {
      return {
        order: { id: null, profile: { name: null, user: {email: null} }, expeditions: [] },
        price: 0,
        date: '',
        file: null,
        value: null,
        uploadPercentage: 0,
        has_photo_upload: false,
        history: {},
        money: {
          decimal: ',',
          thousands: '.',
          prefix: '',
          suffix: '',
          precision: 2,
          masked: false /* doesn't work with directive */
        }
      }
    },
    components: { menuAdmin, footerAdmin },
    computed: {
      ...mapState(['logged'])
  },
  directives: { money: VMoney },
  methods: {
    reproveOrder(){
      let reason = $('#reprove').val()
      if(reason !== ''){
        order.order_reject({order: this.order.id, reason: reason}).then((response)  =>  {
          console.log(response)
          this.getorder(this.$route.params.id)
          $('#hideModal').click()
        }).catch(errors => { this.formErrors(errors) })
      } else {
        this.formErrors({'reprove': 'Um motivo precisa ser informado para o cliente' })
      }
    },
    aproveImages(){
      this.order.status = 1
      this.saveorder()
    },
    uploadFile(){
      if(this.file){
        let formData = new FormData();
        formData.append("file", this.file);
        let order = this.order
        axios.put(CONFIGS.API_SERVER + '/api/upload/'+ this.order.id +'/', formData, {
          headers: {'Content-Type': 'multipart/form-data'},
          onUploadProgress: function( progressEvent ) {
            this.uploadPercentage = parseInt(Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total ));
            let percent = this.uploadPercentage+'%'
            $('.progress-bar').css({'width': percent}).html(percent)
            if(this.uploadPercentage === 100) $('.progress-bar').html('Arquivo enviado')
          }.bind(this)
        }).then(function (response) {
          if(response.status === 200){
            order.file = response.data.file
          }
        })
      }
      return true
    },
    getorder(id){
      let has_photo_upload = this.has_photo_upload
      order.get(id).then((response)  =>  {
        this.order = response.data
        this.price = this.order.price
        this.date = this.formatDate(this.order.date, 'pt-br')

        if(this.order.status === 'Pagamento pendente') this.order.status = 1
        if(this.order.status === 'Pagamento confirmado') this.order.status = 2
        if(this.order.status === 'Cancelado') this.order.status = 3
        if(this.order.status === 'Em análise') this.order.status = 4

        this.order.publications.forEach(function(item){
          if(item.publication.has_photo_upload)
            has_photo_upload = true
        })

        this.has_photo_upload = has_photo_upload

        this.loadLogme()
      })
    },
    loadLogme(){
      logme.get({target: 'order', target_id: this.order.id}).then((response)  =>  {
          this.history = response.data
      })
    },
    saveorder(){
      $("#sucessUpdate").hide()
      order.order_update_status({ order: this.order.id, status: this.order.status }).then((response) => {
        if(response.status === 200){
        order.update({
          "nfe": this.order.nfe,
          "note": this.order.note
        }, this.order.id).then(() => {
          this.loadLogme()
          $("#sucessUpdate").show()
      }).catch(errors => { this.formErrors(errors) })
      } else {
        alert('ATENÇÃO: Não foi possivel atualizar o pedido!');
      }
    }).catch(errors => { this.formErrors(errors) })
    }
  },
  mounted(){
    if(this.$route.params.id !== undefined && this.$route.params.id > 0)
      this.getorder(this.$route.params.id)
  }
  }
</script>

<style scoped>
  .jumbotron-fluid{
    padding-top: 100px;
    padding-bottom: 20px;
    margin-bottom: 10px;
  }
</style>
